import { render, staticRenderFns } from "./list.vue?vue&type=template&id=7ad898dc&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad898dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ad898dc')) {
      api.createRecord('7ad898dc', component.options)
    } else {
      api.reload('7ad898dc', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=7ad898dc&scoped=true", function () {
      api.rerender('7ad898dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/object/components/list.vue"
export default component.exports